// Global live-call state for the away bar (one live call at a time).
import { useSyncExternalStore } from "react";

let live = null; // { id, name, startedAt, muted }
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export const setLive = (v) => { live = v ? { ...(live || {}), ...v } : null; emit(); };
export const useLive = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => live);
export const mmss = (ms) => { const s = Math.max(0, Math.floor(ms / 1000)); return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`; };
